<template>
  <div
    @mouseenter="clearTimer"
    @mouseleave="startTimer"
  >
    <v-snackbar
      v-model="visible"
      :style="{ zIndex: message.id + 999 }"
      :color="message.type"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      <div v-if="message.text.lastIndexOf('_') !== -1">
        {{ $t(`snackbar.${message.text}`) }}
      </div>
      <div v-else>{{ message.text }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="close"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        visible: true,
        mode: '',
        timeout: 6000,
        text: '',
        color: null,
        timer: null,
        closed: false,
        duration: this.timeout,
        type: 'info',
      }
    },
    mounted() {
      this.duration = this.timeout
      this.startTimer()
      document.addEventListener('keydown', this.keydown)
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.keydown)
    },
    methods: {
      close() {
        this.visible = false
        this.closed = true
        setTimeout(() => {
          this.$store.commit('snackbar/deleteMessage', this.message.id)
        }, 500)
      },
      clearTimer() {
        clearTimeout(this.timer)
      },
      startTimer() {
        if (this.duration > 0) {
          this.timer = setTimeout(() => {
            if (!this.closed) {
              this.close()
              this.duration = 0
            }
          }, this.duration)
        }
      },
      keydown(e) {
        if (e.keyCode === 27 && !this.closed) {
          this.close()
        }
      },
    },
  }
</script>
